import _ from 'lodash';
import { getConfig } from '../utils/support';

// Just a component that sends off the data to the
// actual, registered component based on the config
export default {
  functional: true,
  props: {
    item: { required: true },
    index: { required: true },
    header: { type: Boolean },
    options: { type: Boolean },
  },
  render(h, {
    props, children, data, parent,
  }) {
    const panel = props.item;
    const config = getConfig(panel.key);

    // Used to determine panel "roots"
    data.stackPanel = {
      index: props.index,
      type: panel.key,
      id: panel.id,
      uuid: panel.uuid,
    };

    // Bind to configured property
    data.props = {
      [config.data]: panel.data,
      _errors: panel.errors,
      _header: props.header,
      _options: props.options,
    };

    // For the option view we only need the items, no extra loading stuff
    if (props.options) {
      data.class = 'stack-panel stack-options';

      return h('div', data, _.map(panel.config.options, option => h(option, {
        props: data.props,
      })));
    }

    // Fetch all required data if we haven't done yet
    _.each(config.requires, type => parent.loadShared(type));

    // Render the appropiate component
    let component = config.components[props.header ? 'header' : 'default'];

    if (panel.loading) {
      component = config.components.loading;
    } else if (!_.isEmpty(panel.errors)) {
      component = config.components.error;
    } else if (_.isEmpty(panel.data)) {
      component = config.components.empty;
    }

    if (!props.header) {
      data.class = 'stack-panel';
    }

    return h(component, data, children);
  },

};



// WEBPACK FOOTER //
// ./resources/assets/js/view-stack/components/view.js